// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"626de51dddece4cdc9f3","339":"04f5c3da8df57e92d4c5"}[chunkId] + ".js";
};